module.exports = __webpack_public_path__ + "helveticaneueltstd-lt-webfont.2f9a3b87528d86f16b7d.woff";


//////////////////
// WEBPACK FOOTER
// C:/Users/jboix/source/repos/classic/OficinaAngular/src/assets/fonts/helveticaneueltstd-lt-webfont.woff
// module id = ../../../../../src/assets/fonts/helveticaneueltstd-lt-webfont.woff
// module chunks = styles